import ExclamationCircleFilled from '@ant-design/icons/lib/icons/ExclamationCircleFilled'
import InfoCircleOutlined from '@ant-design/icons/lib/icons/InfoCircleOutlined'
import { Alert, Popover } from 'antd'
import React, { FunctionComponent } from 'react'

import { rcErrorDescription } from '../../utils/rcErrorDescription'

export interface RcInputErrorProps {
  error: number
  children?: React.ReactNode
}

const styles = {
  body: { maxWidth: '300px' },
}

export const RcInputError: FunctionComponent<RcInputErrorProps> = props => {
  const errorCode = props.error || 30
  const content = (
    <div>
      <div className="mb-4">{rcErrorDescription[errorCode].description}</div>
      <Alert
        message={
          rcErrorDescription[errorCode].type === 'warning'
            ? 'Toto rodné číslo bude zpracováno, ale může být chybné.'
            : 'Toto rodné číslo nebude zpracováno, neboť není validní.'
        }
        type={rcErrorDescription[errorCode].type}
        showIcon
      />
    </div>
  )
  if (props.error)
    return (
      <Popover
        styles={styles}
        title={rcErrorDescription[errorCode].title}
        content={content}
        className="cursor-help"
      >
        {props.children ? (
          props.children
        ) : (
          <span
            className={
              rcErrorDescription[errorCode].type === 'warning'
                ? 'text-orange-300'
                : 'text-red-500'
            }
          >
            {rcErrorDescription[errorCode].type === 'warning' ? (
              <InfoCircleOutlined className="mr-2" />
            ) : (
              <ExclamationCircleFilled className="mr-2" />
            )}
            <span className="underline underline-offset-2 decoration-dashed">
              {rcErrorDescription[errorCode].title}
            </span>
          </span>
        )}
      </Popover>
    )
  return <>{props.children}</>
}
